import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft } from "lucide-react";
import { SiteHeader } from "@/components/site-header";

export function ToolDetailsSkeleton() {
    return (
        <div className="flex flex-col h-full">
            <SiteHeader
                title="Tool Details"
                subtitle="Loading tool configuration..."
                backButton={
                    <Button variant="ghost" size="sm" disabled className="gap-2">
                        <ArrowLeft className="h-4 w-4" />
                        Back
                    </Button>
                }
            >
                {/* Tool ID Skeleton */}
                <Skeleton className="h-9 w-[200px]" />

                {/* Action Buttons */}
                <Skeleton className="h-9 w-[100px]" />
                <Skeleton className="h-9 w-[140px]" />
            </SiteHeader>

            <div className="flex-1 overflow-auto">
                <div className="px-4 py-6 md:px-8 md:py-8">
                    <Tabs defaultValue="details" className="space-y-4">
                        <TabsList className="h-11">
                            <TabsTrigger value="details" disabled className="gap-2 px-4">
                                <Skeleton className="h-4 w-4" />
                                <Skeleton className="h-4 w-16" />
                            </TabsTrigger>
                            <TabsTrigger value="connection" disabled className="gap-2 px-4">
                                <Skeleton className="h-4 w-4" />
                                <Skeleton className="h-4 w-20" />
                            </TabsTrigger>
                            <TabsTrigger value="schema" disabled className="gap-2 px-4">
                                <Skeleton className="h-4 w-4" />
                                <Skeleton className="h-4 w-16" />
                            </TabsTrigger>
                            <TabsTrigger value="messages" disabled className="gap-2 px-4">
                                <Skeleton className="h-4 w-4" />
                                <Skeleton className="h-4 w-20" />
                            </TabsTrigger>
                        </TabsList>

                        <TabsContent value="details" className="space-y-4">
                            <div className="rounded-lg border bg-card">
                                <div className="p-6 space-y-4">
                                    {/* Name Field */}
                                    <div className="space-y-2">
                                        <Skeleton className="h-4 w-24" />
                                        <Skeleton className="h-10 w-full" />
                                    </div>

                                    {/* Description Field */}
                                    <div className="space-y-2">
                                        <Skeleton className="h-4 w-32" />
                                        <Skeleton className="h-24 w-full" />
                                    </div>

                                    {/* Async Toggle */}
                                    <div className="flex items-center gap-2">
                                        <Skeleton className="h-6 w-11" />
                                        <Skeleton className="h-4 w-32" />
                                    </div>
                                </div>
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}
